import header from './en/header';
import buttons from './en/buttons';
import home from './en/home';
import search from './en/search';
import companyPages from './en/pages/company';
import contactPages from './en/pages/contact';
import recruitPages from './en/pages/recruit';
import applicationsPages from './en/pages/applications';
import newsPages from './en/pages/news'; 
import productsPages from './en/pages/products';

export default {
  header,
  buttons,
  home,
  search,
  pages: {
    company: companyPages,
    news: newsPages, 
    contact: contactPages,
    recruit: recruitPages,
    applications: applicationsPages,
    products: productsPages
  }
}; 